export const CLIENTS_ROUTE = '/clients';
export const CLIENT_CREATION_ROUTE = '/creation-client';
export const INVITATIONS_IMPORT_ROUTE = '/import-invitations';
export const USERS_ROUTE = '/utilisateurs';
export const PUBLICATIONS_ROUTE = '/publications';
export const TOOLBOX_ROUTE = '/toolbox';
export const SIGNALS_ROUTE = '/signales';
export const CATEGORIES_ROUTE = '/categories';
export const GAMIFICATIONS_ROUTE = '/gamification';
export const PASSWORD_MANAGEMENT_ROUTE = '/gestion-mot-de-passe';
export const STATS_ROUTE = '/statistiques';
export const SECURITY_ROUTE = '/securite';
